import asyncComponent from '../../components/AsyncComponent';

const Contracts = asyncComponent(() => import('../../containers/Contract/ContractList'));

export default Contracts;
